// extracted by mini-css-extract-plugin
export var author = "AuthorInfo-module--author--2hVkp";
export var author__name = "AuthorInfo-module--author__name--1ykIr";
export var author__position = "AuthorInfo-module--author__position--3XXlW";